import createErrorMessage from "@shared/factories/src/errorMessage.factory"
import * as posApi from "@hub/management/src/modules/pos/api/pos.api"

export const listPos = async params => {
  try {
    const data = await posApi.listPos(params)
    return data
  } catch (error) {
    console.error(error)
    window.$vue.$toast({
      type: "error",
      title:
        createErrorMessage(error).getMessage() || "Falha ao obter lista de PDVs"
    })
    throw error
  }
}

export const listRolesAccessTime = async params => {
  try {
    const { data } = await posApi.listRolesAccessTime(params)

    const formatedRoles = data.map(role => ({
      uuid: role.uuid,
      name: role.name,
      searchable: role.searchable,
      days_of_week: [
        {
          active: 1,
          day_of_week: "monday",
          day_of_week_pt: "Segunda-feira",
          start_time: "08:00",
          end_time: "20:00"
        },
        {
          active: 1,
          day_of_week: "tuesday",
          day_of_week_pt: "Terça-feira",
          start_time: "08:00",
          end_time: "20:00"
        },
        {
          active: 1,
          day_of_week: "wednesday",
          day_of_week_pt: "Quarta-feira",
          start_time: "08:00",
          end_time: "20:00"
        },
        {
          active: 1,
          day_of_week: "thursday",
          day_of_week_pt: "Quinta-feira",
          start_time: "08:00",
          end_time: "20:00"
        },
        {
          active: 1,
          day_of_week: "friday",
          day_of_week_pt: "Sexta-feira",
          start_time: "08:00",
          end_time: "20:00"
        },
        {
          active: 1,
          day_of_week: "saturday",
          day_of_week_pt: "Sábado",
          start_time: "08:00",
          end_time: "20:00"
        },
        {
          active: 1,
          day_of_week: "sunday",
          day_of_week_pt: "Domingo",
          start_time: "08:00",
          end_time: "20:00"
        }
      ],
      openCollapsible: true
    }))

    return formatedRoles
  } catch (error) {
    console.error(error)
    window.$vue.$toast({
      type: "error",
      title: createErrorMessage(error).getMessage() || "Falha ao obter Perfis"
    })
    return []
  }
}

export const listActivePos = async params => {
  try {
    const { data } = await posApi.listActivePos(params)

    const posWithChecks = data.pos.map(e => ({
      ...e,
      hasAccess: false,
      favoritePos: false
    }))

    return posWithChecks
  } catch (error) {
    console.error(error)
    window.$vue.$toast({
      type: "error",
      title:
        createErrorMessage(error).getMessage() || "Falha ao obter PDVs ativos"
    })
    return []
  }
}

export const fetchPos = async uuid => {
  try {
    const { data } = await posApi.fetchPos(uuid)

    return data.pos
  } catch (error) {
    console.error(error)
    window.$vue.$toast({
      type: "error",
      title: createErrorMessage(error).getMessage() || "Falha ao obter PDV"
    })
    return {}
  }
}

export const createPos = async data => {
  try {
    await posApi.createPos(data)
    window.$vue.$toast({
      type: "success",
      title: "Ponto de venda criado com sucesso"
    })
  } catch (error) {
    console.error(error)
    window.$vue.$toast({
      type: "error",
      title: createErrorMessage(error).getMessage() || "Falha ao criar PDV"
    })
  }
}

export const editPos = async (data, uuid) => {
  try {
    await posApi.editPos(data, uuid)
    window.$vue.$toast({
      type: "success",
      title: "Ponto de venda alterado com sucesso"
    })
  } catch (error) {
    console.error(error)
    window.$vue.$toast({
      type: "error",
      title: createErrorMessage(error).getMessage() || "Falha ao editar PDV"
    })
  }
}

export const changeStatusPos = async (data, uuid) => {
  try {
    await posApi.changeStatusPos(data, uuid)
    window.$vue.$toast({
      type: "success",
      title: "Status do PDV alterado com sucesso"
    })
  } catch (error) {
    console.error(error)
    window.$vue.$toast({
      type: "error",
      title:
        createErrorMessage(error).getMessage() ||
        "Falha ao alterar status do PDV"
    })
  }
}

export const getAddressFromPostcode = async postcode => {
  try {
    const { data } = await posApi.getAddressFromPostcode(postcode)
    return data
  } catch (error) {
    console.error(error)
    window.$vue.$toast({
      type: "error",
      title: createErrorMessage(error).getMessage()
    })
  }
}

export const getAllPos = async () => {
  try {
    const { data } = await posApi.getAllPos()
    return data.pos
  } catch (error) {
    console.error(error)
    window.$vue.$toast({
      type: "error",
      title: createErrorMessage(error).getMessage()
    })
  }
}

export const listPossibleUserPos = async () => {
  try {
    const { data } = await posApi.listPossibleUserPos()
    return data
  } catch (error) {
    console.error(error)
    window.$vue.$toast({
      type: "error",
      title: createErrorMessage(error).getMessage()
    })
    throw error
  }
}
